import CamposInformaciones from '../campos/CamposInformaciones.js';
import TablaInformaciones from '../tablas/TablaInformaciones.js';
import * as Campos from '../../constantes/Campos.js';
import * as FuncionesFecha from '../../funciones/FuncionesFecha.js';

// Funciones para CuadroEditableLista

export const armarFilasTabla = (lista, idElegido, onEditarItem, onEliminarItem) => {
  return (
    <TablaInformaciones
      lista={lista}
      idElegido={idElegido}
      onEditarItem={onEditarItem}
      onEliminarItem={onEliminarItem}
    />
  );
};

export const OrdenarLista = (itemA, itemB) => {
  const fechaFuenteA = FuncionesFecha.CamposToDate(
    itemA.anioFuente,
    itemA.mesFuente,
    itemA.diaFuente
  );
  const fechaFuenteB = FuncionesFecha.CamposToDate(
    itemB.anioFuente,
    itemB.mesFuente,
    itemB.diaFuente
  );
  return fechaFuenteA - fechaFuenteB;
};

// Funciones para EditarItemLista

export const CamposEdicion = (idPadre, item, editar, actualizar, onCampoChange) => {
  return (
    <CamposInformaciones
      idPadre={idPadre}
      item={item}
      editar={editar}
      actualizar={actualizar}
      onCampoChange={onCampoChange}
    />
  );
};

export const OnCampoChange = (item, campo, valor) => {
  switch (campo) {
    case Campos.Informacion.TIPO_INFORMACION: {
      return { ...item, tipoInformacion: valor };
    }
    case Campos.Informacion.FUENTE_INFORMACION: {
      return { ...item, fuenteInformacion: valor };
    }
    case Campos.Informacion.NUMERO_FUENTE: {
      return { ...item, numeroFuente: valor };
    }
    case Campos.Informacion.FECHA_FUENTE: {
      return {
        ...item,
        anioFuente: valor[FuncionesFecha.ANIO],
        mesFuente: valor[FuncionesFecha.MES],
        diaFuente: valor[FuncionesFecha.DIA],
      };
    }
    case Campos.Informacion.DETALLE_FUENTE: {
      return { ...item, detalle: valor };
    }
    case Campos.Informacion.OBSERVACIONES: {
      return { ...item, observaciones: valor };
    }
    default: {
      throw new Error('Campo ' + campo + ' no definido');
    }
  }
};

export const ValidarItemGrabar = (item) => {
  let error = '';
  if (!item) {
    error = 'No se informaron datos para la información';
  } else if (!item.tipoInformacion) {
    error = 'Debe seleccionar el tipo de información';
  } else if (
    item.anioFuente < FuncionesFecha.ANIO_MINIMO ||
    item.anioFuente > FuncionesFecha.ANIO_MAXIMO
  ) {
    error = 'La fecha de la fuente es inválida';
  } else {
    const fechaFuente = FuncionesFecha.CamposToFechaBaseInicial(
      item.anioFuente,
      item.mesFuente,
      item.diaFuente
    );
    if (!fechaFuente < FuncionesFecha.FechaBaseMinima()) {
      error = 'La fecha de publicación es inválida';
    } else if (
      item.fechaValidacion < FuncionesFecha.FechaBaseMinima() ||
      item.fechaValidacion > FuncionesFecha.FechaBaseActual()
    ) {
      error = 'La fecha de validación es inválida';
    }
  }
  return error;
};
